import { render, staticRenderFns } from "./personel.vue?vue&type=template&id=7f10f3a2&scoped=true&"
import script from "./personel.vue?vue&type=script&lang=js&"
export * from "./personel.vue?vue&type=script&lang=js&"
import style0 from "./personel.vue?vue&type=style&index=0&id=7f10f3a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f10f3a2",
  null
  
)

export default component.exports